// eslint-disable-next-line @typescript-eslint/no-unused-vars
import React from 'react';

function NonAuthLayout({ page }: { page: JSX.Element }) {
    return page;
}

export default NonAuthLayout;